<template>
  <nav
    :class="{ sp: $device.isMobile }"
    class="topicpath"
    aria-label="現在位置"
  >
    <ol class="topicpath-list container">
      <li
        v-for="(breadcrumb, index) in list"
        :key="index"
        class="topicpath-item"
      >
        <nuxt-link :to="breadcrumb.url" class="topicpath-link">
          <span
            v-if="isHome(breadcrumb)"
            aria-hidden="true"
            class="icon-home"
          ></span>
          <span>{{ breadcrumb.name }}</span>
        </nuxt-link>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    isHome(breadcrumb) {
      return breadcrumb.url === '/'
    }
  }
}
</script>
